import { useEffect, useState, memo, useMemo } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";

import { Section } from "../common/HtmlTags/Section/Section";
import { Container } from "../common/HtmlTags/Container/Container";
import { Paragraph } from "../common/HtmlTags/Paragraph/Paragraph";
import { Span } from "../common/HtmlTags/Span/Span";
import AuthBanner from "../feature/AuthBanner/AuthBanner";
import { PAGE_STATIC_LINKS } from "../../utils/constants";
import { PageStaticLink } from "../../types";
import "./AuthLayout.css";
import { ZelpyeLogo } from "../common/ZelpyeLogo/ZelpyeLogo";
import { ZELPYE_LOGO_VARIANT } from "../common/ZelpyeLogo/ZelpyeLogo.constants";
const AuthLayout = memo(() => {
  const [isLogin, setIsLogin] = useState(true);
  const location = useLocation();

  const loginState = useMemo(() => {
    return location.pathname !== "/auth/signup";
  }, [location.pathname]);

  useEffect(() => {
    setIsLogin(loginState);
  }, [loginState]);

  const staticLinksRender = () => {
    return (
      <Container className="auth-static-links-wrap">
        {PAGE_STATIC_LINKS.map((link: PageStaticLink) => (
          <Link to={link.link} key={link.label} className="auth-links">
            {link.label}
          </Link>
        ))}
      </Container>
    )
  }

  const bottomLinkContent = useMemo(() => {
    const search = location.search;
    if (!isLogin)
      return (
        <Paragraph>
          <Span>Already have an account?</Span>
          <Link to={`/auth/login${search}`} className="auth-links">
            Sign in
          </Link>
        </Paragraph>
      );

    return (
      <Paragraph>
        <Span>Don't have an account?</Span>
        <Link to={`/auth/signup${search}`} className="auth-links">
          Sign up
        </Link>
      </Paragraph>
    );
  }, [isLogin, location.search]);

  return (
    <Section className="auth-wrapper">
      <AuthBanner />
      <Container className="auth-form-wrapper">
        <Container className="auth-form-cont">
          <Container className="auth-header-wrap">
            <ZelpyeLogo variant={ZELPYE_LOGO_VARIANT.TEXT_LOGO} />
          </Container>
          <Outlet />
        </Container>
        <Container className="auth-bottom-link-wrap">
          {bottomLinkContent}
          {staticLinksRender()}
        </Container>
      </Container>
    </Section>
  );
});

AuthLayout.displayName = "AuthLayout";

export default AuthLayout;
